export default __webpack_public_path__ + "static/media/inlaks.fe94cab2.jpg";